import { ImageLoaderProps } from "next/legacy/image";

export const roots = {
  ghost: "https://areahub-knowledge-center.imgix.net",
  images: "https://areahub-images.imgix.net",
};

interface ImgixLoadOpts extends ImageLoaderProps {
  type: "ghost" | "images";
}

function normalizeSrc(src: string, type: "ghost" | "images"): string {
  switch (type) {
    case "ghost":
      return src.replace("https://s3.amazonaws.com/areahub-ghost", roots[type]);
    case "images":
      return `${roots?.images}/${src}`;
  }
}

export function imgixLoader({ type, src, width, quality }: ImgixLoadOpts) {
  // Demo: https://static.imgix.net/daisy.png?format=auto&fit=max&w=300

  const params = ["auto=format", "fit=max", "w=" + width];
  let paramsString = "";
  if (quality) {
    params.push("q=" + quality);
  }

  if (params.length) {
    paramsString = "?" + params.join("&");
  }
  if (src.includes("https://")) {
    return `${src}${paramsString}`;
  }
  if (src.includes(".gif")) {
    return `${normalizeSrc(src, type)}`;
  }

  return `${normalizeSrc(src, type)}${paramsString}`;
}
